module.exports = __webpack_public_path__ + "static/civicAllianceBlack-8ad18ff15e78bd077bea31f955620624.png";